import React from 'react';
import { List, Map } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import capitalize from 'capitalize';

const CabinClass = ({ serviceDetail = Map() }) => (
  <div className='col-wrapper-va cabin-class'>
    <dl className='v-align'>
      <dt>{capitalize(serviceDetail.get('cabinClass', '').toLowerCase())}</dt>
      <dd>
        <BookingCode serviceDetail={serviceDetail} />
      </dd>
      {/* TODO: Fare rules? */}
      {/*<dd>Fare Rules</dd>*/}
    </dl>
  </div>
);

CabinClass.propTypes = {
  serviceDetail: ImmutablePropTypes.map.isRequired,
};

const BookingCode = ({ serviceDetail }) =>
  serviceDetail.has('connectingFlightDetail') ? (
    <span className='code'>
      {serviceDetail
        .get('connectingFlightDetail')
        .reduce((r, cfd) => r.push(cfd.get('airlineBookingCode')), new List())
        .join()}
      <br />
      {serviceDetail
        .get('connectingFlightDetail')
        .reduce((r, cfd) => r.push(cfd.get('airlineBookingClass')), new List())
        .join()}
    </span>
  ) : serviceDetail.has('airlineBookingCode') ? (
    <span className='code'>
      {serviceDetail.get('airlineBookingCode')} <br />
      {serviceDetail.get('airlineBookingClass')}
    </span>
  ) : null;

export default CabinClass;



// WEBPACK FOOTER //
// ./src/ndc/offer/CabinClass.js